import create from 'zustand'
import { Brand, BrandType } from '@nsw-paginas-deslogadas/constants'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { ProductPrepare, Mapping, Product } from '@nsw-paginas-deslogadas/typings'

export type AppDispatch = {
    setBrand: (brand: BrandType | null) => void
    setProduct: (product: Product | null) => void
    setContextStates: (states: Partial<AppState>) => void
}

export type AppState = {
    brand: BrandType
    mapping: Mapping
    product: Product
    prepare: ProductPrepare[]
}

const initialState: AppState = {
    brand: Brand.nav as BrandType,
    mapping: {} as Mapping,
    product: {} as Product,
    prepare: [] as ProductPrepare[],
}

const useAppContext = create<AppState & AppDispatch>(set => ({
    ...initialState,
    setBrand: (brand: BrandType | null): void => {
        set(state => {
            if (brand) {
                state.brand = { ...brand }
                state.mapping = BrandMapping[brand.mappingId]
            }
        })
    },
    setProduct: (product: Product): void => {
        set(state => {
            if (product) state.product = product
        })
    },
    setPrepare: (prepare: ProductPrepare[]): void => {
        set(state => {
            if (prepare) state.prepare = prepare
        })
    },
    setContextStates: (states: Partial<AppState>): void => {
        set(state => {
            state = Object.assign({ ...state }, { ...states })
            state.mapping = BrandMapping[state.brand.mappingId]
            return { ...state }
        })
    },
}))

export { useAppContext }
